export function eventKundefilialeGesetzt() {
    document.dispatchEvent(new CustomEvent('kundenfiliale-gesetzt', { bubbles: true }));
}